module.exports = __webpack_public_path__ + "img/icon_parkingService.3749213f.png";